import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "@phosphor-icons/react";
import { useT } from "../context/LangContext";

export default function PaymentCancel() {
  const { t } = useT();
  const c = t.payment;
  return (
    <section className="min-h-screen flex items-center justify-center px-5 py-32" data-testid="payment-cancel-page">
      <div className="max-w-lg text-center">
        <XCircle size={72} weight="duotone" className="mx-auto text-stone" />
        <h1 className="mt-8 font-display font-extrabold tracking-tighter text-4xl text-ink">{c.cancelTitle}</h1>
        <p className="mt-4 text-lg text-stone">{c.cancelBody}</p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link to="/sostienici" data-testid="cancel-retry-btn" className="inline-flex items-center gap-2 rounded-full bg-terracotta px-7 py-3.5 font-semibold text-white transition-colors duration-200 hover:bg-terracotta-dark">
            {c.retry} <ArrowRight size={18} />
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 rounded-full border border-ink/20 px-7 py-3.5 font-semibold text-ink transition-colors duration-200 hover:bg-ink hover:text-bone">
            {c.home}
          </Link>
        </div>
      </div>
    </section>
  );
}
